import React, { useState } from 'react';
import { postAnulacionReversionOrdenApi, postSolicitudAnulacionOrdenApi } from "../../../api/axios";
import ModalItem from "../../General/Modal";
import { toast } from "react-toastify";
import { hasMetodoPagoPermitido } from "../../../helper/ordenHelper";

const BTN = Object.freeze({ CON_DEVOL: 1, SIN_DEVOL: 2, RECHAZO: 3 });
const METODOS_PERMITIDOS = Object.freeze([
  'TARJETA DE CRÉDITO',
  'TARJETA DÉBITO',
  'CONTADO A TRAVÉS DE COBROEXPRESS O DEPÓSITO Y/O TRANSFERENCIA BANCARIA',
  'MERCADOPAGO BILLETERA'
]);

export default function AnulacionReversion({
  idOrden,
  idSeller,
  motivosRechazo = [],
  motivoAnulacionSeller,
  goToOrdenes,
  orden,
  setHabilitarInputs,
  setHabilitarInputsVte
}) {
  const [motivoRechazo, setMotivoRechazo] = useState("");
  const [isFetching, setIsFetching] = useState(false);

  const enviarSolicitudAnulacion = (request, continuarConReversion = false) => {
    setIsFetching(true);
    return postSolicitudAnulacionOrdenApi(request)
      .then(() => {
        toast.success("Anulación enviada correctamente");
        if (continuarConReversion) {
          return postAnulacionReversionOrdenApi(request).then(() => {
            toast.success("Estado de orden actualizado");
            goToOrdenes();
          });
        }
      })
      .catch(err => {
        const errs = err?.response?.data?.errores;
        if (Array.isArray(errs) && errs.length) errs.forEach(e => toast.error(e));
        else toast.error("No se pudo enviar la solicitud o actualizar el estado");
      })
      .finally(() => setIsFetching(false));
  };

  const isValidRechazo = (buttonId) => {
    if (buttonId === BTN.RECHAZO) {
      if (!motivoRechazo) {
        toast.warn("Seleccione un motivo de rechazo");
        return false;
      }
    } else {
      // Si querés forzar que exista motivoAnulacionSeller en CON_DEVOL / SIN_DEVOL, descomentá:
      // if (!Number(motivoAnulacionSeller?.idMotivo)) {
      //   toast.warn("La solicitud de anulación no tiene motivo");
      //   return false;
      // }
    }
    return true;
  };

  const postAnulacion = (buttonId) => {
    const cupones = orden?.pago?.cupones ?? [];
    const tieneCupones = cupones.length > 0;
    const metodoPermitido = hasMetodoPagoPermitido(cupones, METODOS_PERMITIDOS);

    if (
        buttonId === BTN.CON_DEVOL &&
        orden?.pago?.cupones?.some(c => c.idTipoEntidad !== 8 && c.idTipoEntidad !== 14)
    ) {
      const idMotivo = Number(motivoAnulacionSeller?.idMotivo || 0)
      if (!idMotivo) {
        toast.warn("La solicitud de anulación no tiene motivo");
        return;
      }
      if (metodoPermitido) {
        setHabilitarInputs(true);
        return;
      }
      if (!metodoPermitido && tieneCupones) {
        const req = { idVenta: idOrden, idSeller, idMotivoAnula: 1, solicitarAnulacion: true };
        return enviarSolicitudAnulacion(req, true);
      }
      if (!tieneCupones) {
        setHabilitarInputsVte(true);
        return;
      }
    }

    if (buttonId === BTN.SIN_DEVOL || (
      buttonId === BTN.CON_DEVOL &&
      orden?.pago?.cupones?.some(c => c.idTipoEntidad === 8 || c.idTipoEntidad === 14)
    )) {
      const idMotivo = motivoAnulacionSeller?.idMotivo && Number(motivoAnulacionSeller.idMotivo) !== 0
        ? Number(motivoAnulacionSeller.idMotivo)
        : Number(orden.motivoAnulacion.idMotivo);
      if (!idMotivo && orden?.motivoAnulacion?.idMotivo === 0) {
        toast.warn("La solicitud de anulación no tiene motivo");
        return;
      }

      const requestAnulacion = {
        idVenta: orden.idOrden,
        idSeller: idSeller,
        idMotivoAnulacion: idMotivo,
        solicitarAnulacion: true
      };

      const requestMin = {
        idVenta: orden.idOrden,
        devolucionDinero: buttonId === BTN.CON_DEVOL ? true : false,
        //devolucionDinero: false,
        rechazado: false,
        idSeller: idSeller,
        idMotivoAnula: idMotivo,
      };

      setIsFetching(true);
      if (orden?.motivoAnulacion?.idMotivo !== 0) {
        // Solo ejecuta esto si el motivo es distinto de 0
        postAnulacionReversionOrdenApi(requestMin)
          .then(() => {
            toast.success("Solicitud de anulación enviada");
            goToOrdenes();
          })
          .catch(err => {
            const errs = err?.response?.data?.errores;
            if (Array.isArray(errs) && errs.length) errs.forEach(e => toast.error(e));
            else toast.error("No se pudo enviar la solicitud");
          })
          .finally(() => setIsFetching(false));
      } else {
        // Si el motivo es 0, sigue el flujo anterior
        postSolicitudAnulacionOrdenApi(requestAnulacion)
          .then(res => {
            toast.success("Solicitud de anulación enviada");
            return postAnulacionReversionOrdenApi(requestMin)
              .then(() => {
                toast.success("Solicitud de anulación enviada");
                goToOrdenes();
              });
          })
          .catch(err => {
            const errs = err?.response?.data?.errores;
            if (Array.isArray(errs) && errs.length) errs.forEach(e => toast.error(e));
            else toast.error("No se pudo enviar la solicitud");
          })
          .finally(() => setIsFetching(false));
      }
    }

    if (buttonId === BTN.RECHAZO) {
      if (!motivoRechazo) {
        toast.warn("Seleccione un motivo de rechazo");
        return;
      }
      const reqRechazo = {
        idVenta: idOrden,
        idSeller,
        idMotivoAnula: 1,
        devolucionDinero: false,
        rechazado: true,
      };

      setIsFetching(true);
      return postAnulacionReversionOrdenApi(reqRechazo)
        .then(() => {
          toast.success("Rechazo de anulación enviado");
          goToOrdenes();
        })
        .catch(err => {
          const errs = err?.response?.data?.errores;
          if (Array.isArray(errs) && errs.length) errs.forEach(e => toast.error(e));
          else toast.error("No se pudo rechazar la anulación");
        })
        .finally(() => setIsFetching(false));
    }
  };

  const existeAnulado = orden?.estado?.some(e => e.idEstado === 5);
  return (
    <div className="row mb-3">
      <div className="col-12">
        {!(orden?.anulacionMegatone?.anulado || existeAnulado) && (
          <div className="d-flex align-items-center flex-wrap">
            {[
              { id: BTN.CON_DEVOL, label: "Anular con devolución" },
              { id: BTN.SIN_DEVOL, label: "Anular sin devolución" },
            ].map((button) => (
              <ModalItem
                key={button.id}
                disabled={isFetching}
                text={`¿Desea ${button.label.toLowerCase()}?`}
                onDelete={() => postAnulacion(button.id)}
                validationHandler={() => isValidRechazo(button.id)}
                btnStyle="btn btn-sm background-rojo-megatone me-2"
                btnText={button.label}
              />
            ))}

            {orden?.motivoAnulacion?.idMotivo !== 0 && (
              <>
                <ModalItem
                  key={BTN.RECHAZO}
                  disabled={isFetching}
                  text="¿Desea rechazar la anulación?"
                  onDelete={() => postAnulacion(BTN.RECHAZO)}
                  validationHandler={() => isValidRechazo(BTN.RECHAZO)}
                  btnStyle="btn btn-sm background-rojo-megatone me-2"
                  btnText="Rechazar anulación"
                />

                {orden?.motivoAnulacion?.idMotivo !== 0 && !existeAnulado && (
                  <div style={{ minWidth: 220 }}>
                    <label className="me-2 mb-0">Motivo de rechazo</label>
                    <select
                      className="form-control"
                      value={motivoRechazo}
                      onChange={(e) => setMotivoRechazo(e.target.value)}
                    >
                      <option value=""></option>
                      {motivosRechazo?.map((motivo, index) => (
                        <option key={index} value={motivo.id}>
                          {motivo.descripcion}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
